import React, { useState } from 'react'; // Import useState for toggle logic
import { FaChevronDown, FaChevronUp } from 'react-icons/fa'; // Arrow icons for toggle

const FAQ = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false); // State to track if the FAQ is open or closed

  const toggleFAQ = () => setIsOpen(prevState => !prevState); // Toggle FAQ answer visibility

  return (
    <div className={`faq ${isOpen ? 'open' : ''}`} onClick={toggleFAQ}>
      <div className="faq__header">
        <h4>{question}</h4>
        <span className="faq__icon">
          {isOpen ? <FaChevronUp /> : <FaChevronDown />} {/* Toggle icon */}
        </span>
      </div>
      {isOpen && <p className="faq__answer">{answer}</p>} {/* Display answer if open */}
    </div>
  );
};

export default FAQ;
